import { api } from './client'

export interface TeamMemberWorkload {
  user_id: string
  name: string
  role: string
  active_tasks: number
  overdue_tasks: number
  pending_tasks: number
  in_progress_tasks: number
  load_score: number
  capacity: 'available' | 'busy' | 'overloaded'
}

export interface TeamWorkloadResponse {
  members: TeamMemberWorkload[]
  unassigned_count: number
  total_active: number
}

export interface TeamTimeSummaryMember {
  user_id: string
  name: string
  hours: number
}

export interface TeamTimeSummaryResponse {
  period: { from: string; to: string }
  total_hours: number
  members: TeamTimeSummaryMember[]
}

export const teamApi = {
  workload: (): Promise<TeamWorkloadResponse> => {
    return api.get('/api/v1/team/workload')
  },

  timeSummary: (from_date?: string, to_date?: string): Promise<TeamTimeSummaryResponse> => {
    const params = new URLSearchParams()
    if (from_date) params.append('from_date', from_date)
    if (to_date) params.append('to_date', to_date)
    const query = params.toString()
    return api.get(`/api/v1/timelogs/team-summary${query ? `?${query}` : ''}`)
  },
}
